import React, { useEffect, useRef, useState } from "react";
import { CloudDownloadOutlined } from "@ant-design/icons";
import Logo from "../../assets/nutrackx.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useSelector } from "react-redux";
const AttendanceTable = ({ empAttendance }) => {
  const [sysDate, setSysDate] = useState('')
  const { users } = useSelector((state) => state.user || {})
  const pdfRef = useRef();
  const headerRef = useRef();
  const handleDownload = async () => {
    await downloadPDF()
  };
  const downloadPDF = async () => {

    const input = pdfRef.current;
    const headerValues = headerRef.current;

    const headerCanvas = await html2canvas(headerValues, { scale: 1 }); // Reduce scale
    const headerData = headerCanvas.toDataURL("image/jpeg", 0.6); // Compress header image with JPEG and quality 0.6

    const pdf = new jsPDF("p", "mm", "a4");
    const imgWidth = 210;
    const pageHeight = 297;
    const headerHeight = 20;
    const footerHeight = 16;
    const contentHeight = pageHeight - headerHeight - footerHeight;

    const rows = Array.from(input.querySelectorAll("tr"));
    const totalRows = rows.length;
    const rowsPerPage = 19;
    const totalPages = Math.ceil(totalRows / rowsPerPage);

    const applyHeaderStyle = (row) => {
      row.style.height = "40px";
      row.style.fontSize = "24px";
      row.style.backgroundColor = "#CCCCCC";
      row.style.boxSizing = "border-box";
    };
    applyHeaderStyle(rows[0]);
    const secondRowClone = rows[0].cloneNode(true);
    applyHeaderStyle(secondRowClone);

    for (let i = 0; i < totalPages; i++) {
      const startRow = i * rowsPerPage;
      const endRow = Math.min(startRow + rowsPerPage, totalRows);
      const tableChunk = document.createElement("table");
      tableChunk.style.width = input.offsetWidth + "px";
      if (i > 0) {
        tableChunk.appendChild(secondRowClone.cloneNode(true));
      }

      rows.slice(startRow, endRow).forEach((row, rowIndex) => {
        // if (i > 0 && rowIndex === 0) return;
        const rowClone = row.cloneNode(true);
        tableChunk.appendChild(rowClone);
      });

      document.body.appendChild(tableChunk);
      const chunkCanvas = await html2canvas(tableChunk, { scale: 1 });
      document.body.removeChild(tableChunk);

      const imgData = chunkCanvas.toDataURL("image/jpeg", 0.6);

      pdf.addImage(headerData, "PNG", 0, 0, imgWidth, headerHeight);
      const imgHeight = (chunkCanvas.height * imgWidth) / chunkCanvas.width;
      const contentY = headerHeight;
      pdf.addImage(imgData, "PNG", 0, headerHeight, imgWidth, imgHeight);

      pdf.setFontSize(8);
      const pageNumText = `Page ${i + 1} of ${totalPages}`;
      const pageNumTextWidth = pdf.getTextWidth(pageNumText);
      pdf.text(pageNumText, imgWidth - pageNumTextWidth - 4, pageHeight - 5);
      pdf.text(`Printed On: ${new Date().toLocaleDateString("en-GB")} ${new Date().toLocaleTimeString()}`, 10, pageHeight - 5);

      if (i < totalPages - 1) {
        pdf.addPage();
      }
    }

    // Save the PDF
    pdf.save(`${sysDate}.pdf`);

  };
  const td = `py-4 border-b w-[11%] text-[12px] sm:text-[14px] md:text-[16px] md:px-6`;
  useEffect(() => {
    setSysDate(empAttendance[0].SYS_DATE)
  }, [empAttendance])

  return (
    <>
      <div className="h-full  ">
        <div className="w-full flex items-center justify-center">
          <p className="flex-1 hidden md:block"></p>
          <h2 className="md:flex-1 p-1 text-center font-semibold text-sm md:text-2xl my-5">
            Today Attendance
          </h2>
          <div className="flex-1 flex">
            <span className="w-fit border-2 border-black dark:border-gray-500 rounded-md flex-col items-center flex md:flex-row">
              <span className="text-[12px] md:text-[14px] w-fit font-semibold p-2 px-1">
                {sysDate}
              </span>
            </span>
            <button className="flex-1 flex justify-around items-center">
              <CloudDownloadOutlined
                onClick={handleDownload}
                className="text-[30px] md:-mt-0 md:text-[35px] text-center"
              />
            </button>
          </div>
        </div>
        <table className="min-w-full  border border-gray-300  dark:border-gray-700 bg-white dark:bg-gray-800 px-3">
          <thead className="bg-primaryPurple dark:bg-lightgrey  text-white">
            <tr className="">
              <th className="w-1/12 py-4 px-3 border-b text-left  font-semibold text-[11px] md:text-[16px] md:px-6 md:w-3/12">
                #
              </th>
              <th className="w-5/12 py-4 border-b text-left  font-semibold text-[11px] md:text-[16px] md:px-6 md:w-3/12">
                Employee Name
              </th>
              <th className="w-2/12 py-4 border-b text-center  font-semibold text-[11px] md:text-[16px] md:px-6 md:w-3/12">
                Time In
              </th>
              <th className="w-2/12 py-4 border-b text-center  font-semibold text-[11px] md:text-[16px] md:px-6 md:w-3/12">
                Time Out
              </th>
            </tr>
          </thead>
          <tbody>
            {(users?.ROLE_TITLE === "HR" ||users?.ROLE_TITLE === "Admin" || users?.ROLE_TITLE === "Accountant"   
              ? empAttendance.filter(att => att.ATTENDANCE_STATUS !== "Time Not Started")
              : empAttendance
            ).map((att, index) => {
              let statusText = "Holiday";
              
              if (att) {
                if (att.ATTENDANCE_STATUS === "Absent") {
                  statusText = "Absent";
                } else if (att.ATTENDANCE_STATUS === "Leave") {
                  statusText = "Leave";
                } else if (att.ATTENDANCE_STATUS === "Late") {
                  statusText = "Late";
                } else if (att.ATTENDANCE_STATUS === "Present") {
                  statusText = "Present";
                } else if (att.ATTENDANCE_STATUS === "Time Not Started") {
                  statusText = "Time Not Started";
                } else if (att.ATTENDANCE_STATUS === "Off") {
                  statusText = "Weekend";
                }
              }

              const isAbsent = statusText === "Absent";
              const isLate = statusText === "Late";
              const isTimeNotStarted = statusText === "Time Not Started";
              const isLeave = statusText === "Leave";
              const isWeekend = statusText === "Weekend";
              
              return (
                <tr
                  key={index}
                  className={`${isAbsent
                    ? "bg-red-200 text-gray-800"
                    : isLate
                      ? "bg-yellow-100 text-gray-800"
                      : isTimeNotStarted
                        ? "bg-purple-100 text-gray-800"
                        : isLeave
                          ? "bg-blue-100 text-gray-800"
                          : isWeekend ?
                            "bg-blue-300 text-gray-800" 
                          : "bg-white dark:bg-gray-400 text-gray-800" 
                    }`}
                >
                  <td className={`px-3 ${td}`}>{index + 1}</td>
                  <td className={`${td}`}>{att.NAME}</td>
                  <td className={`${td} text-center`}>
                    {statusText === "Present" || statusText === "Late"
                      ? att.ENTRYTIME
                      : statusText}
                  </td>
                  <td className={`${td} text-center`}>
                      {att?.ENTRYTIME && att?.LEAVEINGTIME == null ? "Still In" : (att?.LEAVEINGTIME || "-")}
                    {/* {statusText === "Present" ||
                      (statusText === "Late" && att.LEAVEINGTIME)
                      ? "Still In"
                      : att.LEAVEINGTIME || statusText} */}
                  </td>
                </tr>
              );
            })}

          </tbody>
        </table>
      </div>
      <span className="w-[210mm] fixed top-[-9999px] -z-10">
        <div ref={headerRef} className="w-[210mm] flex items-center justify-between border-b-2 bg-gray-200 border-gray-600">
          <div className="">
            <img src={Logo} alt="" height={90} width={150} />
          </div>
          <h1 className="text-[28px] dark:text-gray-800 font-semibold text-center mb-5">
            Attendance Sheet
          </h1>
          <span className="mr-2 text-[20px] dark:text-gray-800">{sysDate}</span>
        </div>
        <div ref={pdfRef} className="">
          <table className="w-[210mm]  border border-gray-300 px-3">
            <thead>
              <tr className="!bg-primaryPurple !text-white">
                <th className="w-2/12 pt-2 pb-4 border-b border-black text-center  font-semibold text-[11px] md:text-[16px]">
                  S.No
                </th>
                <th className="w-4/12 pt-2 pb-4 border-b text-left  font-semibold text-[11px] md:text-[16px]">
                  Employee Name
                </th>
                <th className="w-3/12 pt-2 pb-4 border-b text-left  font-semibold text-[11px] md:text-[16px]">
                  Time In
                </th>
                <th className="w-3/12 pt-2 pb-4 border-b text-left  font-semibold text-[11px] md:text-[16px]">
                  Time Out
                </th>
              </tr>
            </thead>
            <tbody>
              {(users?.ROLE_TITLE === "HR" ||users?.ROLE_TITLE === "Admin" || users?.ROLE_TITLE === "Accountant" 
                ? empAttendance.filter(att => att.ATTENDANCE_STATUS !== "Time Not Started")
                : empAttendance
              ).map((att, index) => {
                let statusText = "Holiday";
                if (att) {
                  if (att.ATTENDANCE_STATUS === "Absent") {
                    statusText = "Absent";
                  } else if (att.ATTENDANCE_STATUS === "Leave") {
                    statusText = "Leave";
                  } else if (att.ATTENDANCE_STATUS === "Late") {
                    statusText = "Late";
                  } else if (att.ATTENDANCE_STATUS === "Present") {
                    statusText = "Present";
                  } else if (att.ATTENDANCE_STATUS === "Time Not Started") {
                    statusText = "Time Not Started";
                  } else if (att.ATTENDANCE_STATUS === "Off") {
                  statusText = "Weekend";
                  }
                }
                const isAbsent = statusText === "Absent";
                const isLate = statusText === "Late";
                const isTimeNotStarted = statusText === "Time Not Started";
                const isLeave = statusText === "Leave";
                const isWeekend = statusText === "Weekend";
                return (
                  <tr key={index}
                    className={`${isAbsent ? "bg-red-200" : isLate ? "bg-yellow-100" : isLeave ? "bg-blue-100" : isWeekend ? "bg-blue-300" : "bg-white"} $`}
                  // onClick={()=>handleSubmit(item)}
                  >
                    <td className={`pt-2 pb-4 border-b text-[12px] sm:text-[14px] md:text-[16px] text-center`}>{index + 1}</td>
                    <td className={`pt-2 pb-4 border-b text-[12px] sm:text-[14px] md:text-[16px]`}>{att.NAME}</td>
                    <td className={`pt-2 pb-4 border-b text-[12px] sm:text-[14px] md:text-[16px]`}>
                      {statusText === "Present" || statusText === "Late" ? att.ENTRYTIME : statusText}
                    </td>
                    <td className={`pt-2 pb-4 border-b text-[12px] sm:text-[14px] md:text-[16px]`}>
                      {statusText === "Present" || statusText === "Late" && !att.LEAVEINGTIME
                        ? "Still In"
                        : att.LEAVEINGTIME || statusText}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </span>
    </>
  );
};

export default AttendanceTable;
